import {PlayerBase} from "../../player/player.base";
import {Component, Injector} from '@angular/core';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError} from "rxjs/operators";




@Component({
  selector: 'app-button',
  template: '<div #component><button style="width: 100%; height: 100%" [style.fontSize]="fontSize" [style.color]="color" [style.backgroundColor]="bgColor" [style.fontFamily]="fontFamily" mat-raised-button (click)="onClick($event)">{{label}}</button></div>',
  styleUrls: []
})
export class ButtonComponent extends PlayerBase {
  label;
  fontSize;
  color;
  bgColor;
  fontFamily;
  fontStyle;

  constructor(protected  injector: Injector) {
    super(injector);
  }


  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        const font = this.data.Button[0].Font[0].$;
        this.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font)
      }),
      switchMap( a => {
          this.fontSize = this.fontStyle.fontSize + 'px';
          this.color = this.fontStyle.fill;
          //this.bgColor = this.fontStyle.fill;
          this.fontFamily = this.fontStyle.fontFamily;
          this.label = this.data.Button[0].$.label;
          this.changeDetectorRef.detectChanges();
          return of('a');
      }),
      catchError( err => this.logError(err) ),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  addTouchListeners(obsList) {
    // use button default animation
  }

  createBackgroundAction() {
      const color = Number(this.data.Background[0].$.color);
      const r = color & 0xff;
      const g = (color>>8) & 0xff;
      const b = (color>>16) & 0xff;
      const alpha = Number(this.data.Background[0].$.alpha);

      this.bgColor = 'rgba(' + b + ',' + g + ',' + r + ',' +  alpha + ')';


  }

    clearEffects() {
        super.clearEffects();
        this.bgColor = '';
    }

}
